export const currency = {
  name: 'currency',
  inserted: async (el, bindings, vnode) => {
    const textPrice = el.innerText.replace(/,/g, '.')
    const integerText = textPrice.split('.')[0]
    const decimalsText = textPrice.split('.')[1]
    const integer = integerText.replace(/\D/g, '')
    const decimals = decimalsText ? decimalsText.replace(/\D/g, '') : '0'
    const price = parseFloat(`${integer}.${decimals}`)
    const store = vnode.context.$store
    let { currency: isoCode = 'USD', baseCurrency = 'USD', symbol = '$', format, withIsoCode = false } = (bindings.value || {})
    if (!isoCode) {
      isoCode = store.getters['currency/currentCurrency']
      symbol = store.getters['currency/currencyData']()?.Symbol ?? '$'
    }
    const displayPrice = await store.dispatch('currency/getPriceInCurrency', { price, toCurrency: isoCode, symbol, format, withIsoCode, fromCurrency: baseCurrency })
    el.innerText = displayPrice
  }
}